module.exports = __webpack_public_path__ + "img/default.80328a52.png";